import { red, gray } from '@ant-design/colors';

export type Palette = {
  primary: string;
  secondary: string;
  ssGreen: string;
  error: string;
  warning: string;
  layoutBg: string;
  bgBase: string;
  contentBg: string;
  contentBgSecondary: string;
  layoutOverlayBg: string;
  layoutOverlayContentBg: string;
  componentBorder: string;
  border: string;
  borderHover: string;
  text: string;
  disabled: string;
  activeItemPrimaryColor: string;
  activeItemSecondary: string;
  imagePlaceholderBg: string;
  imagePlaceholderIconColor: string;
  myInstanceCardBg: string;
  myInstanceCardBorder: string;
  myInstanceBorderHover: string;
  linkColor: string;
  colorPrimaryBg: string;
};

export type ThemeConfig = {
  dark: { colors: Palette };
  light: { colors: Palette };
};

export const themeConfig: ThemeConfig = {
  dark: {
    colors: {
      primary: '#1D6AB9',
      secondary: '#8117A7',
      ssGreen: '#82E580',
      error: red[3],
      warning: gray[3],
      layoutBg: '#1C1D21', // layout background - header, footer, sider
      bgBase: '#23252A', // background - page background
      contentBg: '#2B2C33', // content elements background
      contentBgSecondary: '#363c41', // tabs
      layoutOverlayBg: '#363c41', // components on layout background
      layoutOverlayContentBg: '#5a5c67', // components on layout background greater contrast
      componentBorder: '#464647',
      border: '#464647',
      borderHover: '#6a6a75',
      text: '#ddd',
      disabled: '#515356',
      activeItemPrimaryColor: '#7fbeff', // active item color in sidebar
      activeItemSecondary: '#1d3955',
      imagePlaceholderBg: '#575d63',
      imagePlaceholderIconColor: '#2b2c33',

      myInstanceCardBg: '#363c41',
      myInstanceCardBorder: '#1c1d21',
      myInstanceBorderHover: '#495766',

      linkColor: '#7fbeff',

      // antd override
      colorPrimaryBg: '#1d6ab942',
    },
  },
  light: {
    colors: {
      primary: '#1D6AB9',
      secondary: '#8117A7',
      ssGreen: '#82E580',
      error: red[6],
      warning: gray[6],
      layoutBg: '#ffffff', // layout background - header, footer, sider
      bgBase: '#f5f5f5', // background - page background
      contentBg: '#ffffff', // content elements background
      contentBgSecondary: '#dddddd', // tabs
      layoutOverlayBg: '#eeeeee', // components on layout background
      layoutOverlayContentBg: '#0006', // components on layout background greater contrast
      componentBorder: '#bbbbbb',
      border: '#e9ecef',
      borderHover: '#dddddd',
      text: '#000000',
      disabled: '#b8b8b8',
      activeItemPrimaryColor: '#1D6AB9', // active item color in sidebar
      activeItemSecondary: '#f0f8ff',
      imagePlaceholderBg: '#E6E7E8',
      imagePlaceholderIconColor: '#939598',

      myInstanceCardBg: '#e6e6e6',
      myInstanceCardBorder: '#c9c9c9',
      myInstanceBorderHover: '#a7a7a7',

      linkColor: '#1D6AB9',

      // antd override
      colorPrimaryBg: '#e6f4ff',
    },
  },
};
